forms-tasks-update
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    .row
      .col-12.col-sm-6
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
        inputs-hidden(tag-scope="{ this.tagScope }.inputs.responsible")
        inputs-typeahead-single(tag-scope="{ this.tagScope}.inputs.responsible")
      .col-12.col-sm-6
        .casting-col-wrap(if="{this.opts.phase == 'casting'}")
          inputs-complex-number-and-partition(tag-scope="{ this.tagScope}.inputs.taskable.planned_num")
        .partition-num-wrap(if="{this.opts.phase == 'finishing' || this.opts.phase == 'delivery'}")
          inputs-complex-number-and-partition(tag-scope="{ this.tagScope}.inputs.required_num")
    //- 発送用のフォーム
    .delivery-wrap.row(if="{this.opts.phase == 'delivery'}")
      .col-12.col-sm-6
        .row.form-group
          label.col-md-4.col-form-label
            | {opts.inputs.taskable.location_id.label}
            span.text-danger &nbsp;*
          .col-md-8.clearfix
            inputs-without-label-typeahead-single(tag-scope="{ this.tagScope}.inputs.taskable.location_id")
      .col-12.col-sm-6
        .row.form-group
          label.col-md-4.col-form-label
            | {opts.inputs.taskable.locations_person_id.label}
            span.text-danger &nbsp;*
          .col-md-8.clearfix
            inputs-without-label-typeahead-single(if="{opts.inputs.taskable.location_id.value}" tag-scope="{ this.tagScope}.inputs.taskable.locations_person_id")
      .col-12.col-sm-6
        inputs-typeahead-dubble(tag-scope="{ this.tagScope}.inputs.taskable.delivery_option_ids")
      .col-12.col-sm-6
        inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.taskable.who")
      .col-12.col-sm-6
        inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.taskable.shipfrom_id")
    .row
      .col-12
        inputs-textarea(tag-scope="{ this.tagScope }.inputs.memo")
      .col-12
        inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.tasks.update');
